import Vue              from 'vue'
import VueRouter        from 'vue-router'
import store            from './store';

Vue.use(VueRouter);

const routes = [
    {path: '/',                         name: 'index.main',      component: () => import('./views/Index.vue'), meta: {allow: true}},
    {path: '/signin',                   name: 'signin.main',     component: () => import('./views/Signin.vue'), meta: {requiresAuth: true}},
    {path: '/signup',                   name: 'signup.main',     component: () => import('./views/Signup.vue'), meta: {requiresAuth: true}},
    {path: '/success/:id',              name: 'success.main',    component: () => import('./views/Success.vue'), meta: {allow: true}},
    {path: '/error/:id',                name: 'error.main',      component: () => import('./views/Error.vue'), meta: {allow: true}},
    {path: '/exchange',                 name: 'exchange.main',   component: () => import('./views/Exchange.vue'), meta: {allow: true}},
    {path: '/address/:id',              name: 'address.main',    component: () => import('./views/Address.vue'), meta: {allow: true}},
    {path: '/info',                     name: 'info.main',       component: () => import('./views/Info.vue'), meta: {allow: true}},
    {
        path: '/articles',
        name: 'article.main',
        component: () => import('./views/article/Article.vue'),
        meta: {
            allow: true
        },
        children: [
            {
                path: "/articles",
                name: 'article.list',
                component: () => import('./views/article/List.vue')
            },
            {
                path: "editor/:id",
                name: 'article.editor',
                component: () => import('./views/article/Editor.vue')
            }
        ]
    },
    {
        path: '/article/:id',
        name: 'article.view',
        component: () => import('./views/article/View.vue'),
        meta: {
            allow: true
        }
    },
    {
        path: "/contacts/:id",
        name: 'contact.main',
        component: () => import('./views/contact/Contact.vue'),
        meta: {
            allow: true
        },
        children: [
            {
                path: "/contacts/:id",
                name: 'contact.list.0',
                component: () => import('./views/contact/List.vue')
            },
            {
                path: "/contacts/:id/:transposal",
                name: 'contact.list.1',
                component: () => import('./views/contact/List.vue')
            }
        ]
    },
    {
        path: '/account',
        name: 'account.main',
        component: () => import('./views/account/Account.vue'),
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: "/account",
                name: 'account.personal',
                component: () => import('./views/account/Personal.vue')
            },
            {
                path: "detecting",
                name: 'account.detecting',
                component: () => import('./views/account/Detecting.vue')
            }
        ]
    },
    {
        path: '/explorer',
        name: 'explorer.main',
        component: () => import('./views/explorer/Explorer.vue'),
        meta: {
            allow: true
        },
        children: [
            {
                path: "/explorer",
                name: 'explorer.latest',
                component: () => import('./views/explorer/Latest.vue')
            },
            {
                path: "accounts",
                name: 'explorer.accounts',
                component: () => import('./views/explorer/Accounts.vue')
            },
            {
                path: "block/:id",
                name: 'explorer.block',
                component: () => import('./views/explorer/Block.vue')
            },
            {
                path: "blocks",
                name: 'explorer.blocks',
                component: () => import('./views/explorer/Blocks.vue')
            },
            {
                path: "tx/:id",
                name: 'explorer.tx',
                component: () => import('./views/explorer/tx.vue')
            },
            {
                path: "transactions",
                name: 'explorer.transactions',
                component: () => import('./views/explorer/Transactions.vue')
            }
            ,
            {
                path: "tokens",
                name: 'explorer.tokens',
                component: () => import('./views/explorer/Tokens.vue')
            }
        ]
    },
    {
        path: '/applications',
        name: 'applications.main',
        component: () => import('./views/applications/Applications.vue'),
        meta: {
            allow: true},
        children: [
            {
                path: "/applications",
                name: 'applications.tools',
                component: () => import('./views/applications/Tools.vue')
            },
            {
                path: "dapps",
                name: 'applications.dapps',
                component: () => import('./views/applications/Dapps.vue')
            }
        ]
    },

    {
        path: '/wallet',
        name: 'wallet.main',
        component: () => import('./views/wallet/Wallet.vue'),
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: "/wallet",
                name: 'wallet.transfer',
                component: () => import('./views/wallet/Transfer.vue')
            },
            {
                path: "transactions",
                name: 'wallet.transactions',
                component: () => import('./views/wallet/Transactions.vue')
            },
            {
                path: "setting",
                name: 'wallet.setting',
                component: () => import('./views/wallet/Setting.vue')
            },
            {
                path: "token",
                name: 'wallet.token',
                component: () => import('./views/wallet/Token.vue')
            },
            {
                path: "tokens",
                name: 'wallet.tokens.0',
                component: () => import('./views/wallet/Tokens.vue')
            },
            {
                path: "tokens/main",
                name: 'wallet.tokens.1',
                component: () => import('./views/wallet/Tokens.vue')
            }
        ]
    },
    {
        path: '/api',
        name: 'API',
        component: () => import('./views/API/API.vue'),
        meta: {
            allow: true
        }
    },
    {
        path: '/inbox',
        name: 'inbox.main',
        component: () => import('./views/inbox/Inbox.vue'),
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: "/inbox",
                name: 'inbox.guide',
                component: () => import('./views/inbox/Guide.vue')
            },
            {
                path: "channel/:id",
                name: 'inbox.channel',
                component: () => import('./views/inbox/Channel.vue')
            },
            {
                path: "channel/:id/setting",
                name: 'inbox.setting',
                component: () => import('./views/inbox/Setting.vue')
            }
        ]
    }
];

const router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'active',
    routes
});

router.beforeEach((to, from, next) => {

    if (to.name) {
        store.dispatch('getLocalStorage', 'token').then((token) => {
            if (to.matched.some((record) => record.meta.requiresAuth)) {
                if (!token) {
                    next();
                } else {
                    next({
                        path: '/error/1',
                        query: {
                            redirect: to.fullPath
                        }
                    });
                }
            } else {
                if (!token) {
                    if (to.matched.some((record) => record.meta.allow)) {
                        next();
                    } else {
                        next({
                            path: '/signin'
                        });
                    }
                } else {
                    next();
                }
            }
        });
    } else {
        next({
            path: '/error/1',
            query: {
                redirect: to.fullPath
            }
        });
    }

});

export default router
